import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { Empty, message, Spin, Typography } from "antd";
import { useEffect } from "react";
import { getContracts } from "../api";
import { ContractItem } from "./contract-item";
import styles from "./index.module.scss";

export const ContractsList = () => {
  const { t } = useTranslation();

  const [messageApi, contextHolder] = message.useMessage();

  const { data, isLoading, isError, error } = useQuery({
    queryKey: ["contracts"],
    queryFn: () => getContracts(),
  });

  useEffect(() => {
    if (isError) {
      messageApi.error(
        (error as any)?.response?.data?.message ||
          "An error occurred while receiving the list of contracts",
      );
    }
  }, [isError, error, messageApi]);

  if (isLoading) {
    return (
      <div className={styles.listWrapperLoader}>
        {contextHolder}
        <Spin />
      </div>
    );
  }

  if (!data?.data?.length) {
    return (
      <div className={styles.listWrapper}>
        {contextHolder}
        <Empty
          description={
            <Typography.Text>
              {isError
                ? (error as any)?.response?.data?.message ||
                  "An error occurred while receiving the list of contracts"
                : t("contracts.list_empty")}
            </Typography.Text>
          }
        />
      </div>
    );
  }

  return (
    <div className={styles.list}>
      {contextHolder}
      {data?.data?.map((item) => (
        <ContractItem contract={item} key={item.id} />
      ))}
    </div>
  );
};
